<div class="bubble-container" [ngStyle]="{'background-color': getBubbleColor()}">
    <img *ngIf="icon" src="{{ getIconPath() }}" alt="icon"/>
</div>
